module.exports = __webpack_public_path__ + "img/f3.a8b6a411.png";